import React from 'react';
import { TextWithArticlesMessage } from '../../../domain/richMessage.interface';
import { TextCard } from './TextCard';

interface ArticlesCardProps {
  data: TextWithArticlesMessage;
}

export const ArticlesCard: React.FC<ArticlesCardProps> = ({ data }) => (
  <div>
    <TextCard message={data.text} />
    <div className="flex flex-col gap-2 mt-2">
      {data.articles.map((article, i) => (
        <div key={i} className="bg-grey-96 rounded-xl p-3">
          <p className="text-navy font-bold text-sm leading-snug">{article.title}</p>
          <p className="text-navy-64 text-xs mt-1 leading-relaxed">{article.summary}</p>
          <a
            href={article.url}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1 text-coral text-xs font-semibold mt-2"
          >
            Read more
            <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
              <polyline points="15 3 21 3 21 9" />
              <line x1="10" y1="14" x2="21" y2="3" />
            </svg>
          </a>
        </div>
      ))}
    </div>
  </div>
);
